import { Promotion_service } from "./../services/Promotion.service"
import router from "../router/router"
import { MessageBox, Loading } from 'element-ui';
import moment from 'moment'
const state = {
    typeFile: '',
    dialogVisible: false,
    path_excel: null,
    monthly: null,
    saveRow: [],
    fileForm: null,
    PreviewRows: [],
    erroneousInformation: null,
    data_table: [],
    total: 0,
    loading: false,
    provider: [],
    historyHeader: null,
    titleText: {
        "average_internet_service": "บริการอินเทอร์เน็ต (บาท/MB)",
        "average_mms_service": "ค่าบริการ MMS (บาท/ข้อความ)",
        "average_sms_service": "ค่าบริการ SMS (บาท/ข้อความ)",
        "end_service_date": "วันที่สิ้นสุดให้บริการ",
        "average_voice_remark_en": "เงื่อนไขอื่นๆ (คำอธิบาย ภาษาอังกฤษ)",
        "average_voice_remark_th": "เงื่อนไขอื่นๆ (คำอธิบาย ภาษาไทย)",
        "average_voice_service": "นาทีใดๆสูงสุด (บาท/นาที)",
        "created_promotion_from": "จัดเก็บจาก",
        "internet_GB": "จำนวนทั้งหมด (GB)",
        "internet_service": "ค่าบริการ Internet (บาท)",
        "internet_MB": "จำนวนทั้งหมด (บาทต่อMB)",
        "internet_per_MB": "ค่าบริการ Internet (บาท/MB)",
        "internet_remark_en": "เงื่อนไขบริการอินเทอร์เน็ต (ภาษาอังกฤษ)",
        "internet_speed_remark_th": "เงื่อนไขบริการอินเทอร์เน็ต (ภาษาไทย)",
        "masr_other_service": "Others (คำอธิบาย) Prepaid Postpaid",
        "masr_wifi_service": "Wifi (คำอธิบาย) Prepaid Postpaid",
        "mms_amount": "บริการ MMS (บาทต่อข้อความ)",
        "mms_per_message": "ค่าบริการ MMS (บาท/ข้อความ) Prepaid Postpaid",
        "mms_service": "ค่าบริการ MMS (บาท)",
        "other_service": "Others",
        "other_service_en": "ความเร็วอินเตอร์เน็ต : Others (คำอธิบาย ภาษาอังกฤษ)",
        "other_service_th": "ความเร็วอินเตอร์เน็ต : Others (คำอธิบาย ภาษาไทย)",
        "privilege_content_en": "ให้บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง ภาษาอังกฤษ)",
        "privilege_content_th": "ให้บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง ภาษาไทย)",
        "privilege_device_en": "ให้บริการอื่นๆ (ภาษาอังกฤษ)",
        "privilege_device_th": "ให้บริการอื่นๆ (ภาษาไทย)",
        "privilege_game_en": "ให้บริการเกม (ภาษาอังกฤษ)",
        "privilege_game_th": "ให้บริการเกม (ภาษาไทย)",
        "privilege_other_en": "ให้บริการอื่นๆ (ภาษาอังกฤษ)",
        "privilege_other_th": "ให้บริการอื่นๆ (ภาษาไทย)",
        "privilege_premium_en": "พรีเมี่ยม (ภาษาอังกฤษ)",
        "privilege_premium_th": "พรีเมี่ยม (ภาษาไทย)",
        "privilege_social_en": "ให้บริการโซเชียลมีเดีย (ภาษาอังกฤษ)",
        "privilege_social_th": "ให้บริการโซเชียลมีเดีย (ภาษาไทย)",
        "promotion_banner": "ลิงก์รูปโฆษณา หรือรายการส่งเสริมการขาย",
        "promotion_condition_en": "ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)",
        "promotion_condition_th": "ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)",
        "promotion_link_url": "ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ",
        "promotion_ussd": "หมายเลข USSD สำหรับเปลี่ยนรายการส่งเสริมการขาย",
        "signal_900": "900 MHz",
        "signal_1800": "1800 MHz",
        "signal_2100": "2100 MHz",
        "signal_other": "ย่านคลื่นความถี่อื่นๆ",
        "sms_amount": "บริการ SMS (บาทต่อข้อความ)",
        "sms_per_message": "ค่าบริการ SMS (บาท/ข้อความ) Prepaid Postpaid",
        "sms_service": "ค่าบริการ SMS (บาท)",
        "voice_minute": "ปริมาณเสียง (บาทต่อนาที)",
        "voice_per_minute": "ค่าบริการ (บาท/นาที) Prepaid Postpaid",
        "voice_per_second": "ค่าบริการ (บาท/วินาที)",
        "voice_remark": "เงื่อนไขบริการเสียง",
        "voice_remark_en": "เงื่อนไขบริการเสียง (ภาษาอังกฤษ)",
        "voice_remark_th": "เงื่อนไขบริการเสียง (ภาษาไทย)",
        "voice_second": "ปริมาณเสียง (บาทต่อวินาที)",
        "voice_service": "ค่าบริการเสียง (บาท)",
        "wifi_service": "Wifi (คำอธิบาย)",
        "wifi_service_en": "Wifi (คำอธิบาย ภาษาอังกฤษ)",
        "wifi_service_th": "Wifi (คำอธิบาย ภาษาไทย)",
        "other_service_en_mscpu": "ค่าบริการด้านข้อมูล (11.2) เงื่อนไขอื่นๆ (คำอธิบาย ภาษาอังกฤษ)",
        "other_service_th_mscpu": "ค่าบริการด้านข้อมูล (11.2) เงื่อนไขอื่นๆ (คำอธิบาย ภาษาไทย)"
    },
    histories : {},
    download_form : null,
    download_data : null,
    fields: [{
        label: 'รหัสรายการส่งเสริมการขาย',
        value: 'promotion_code'
    }, {
        label: 'ชื่อรายการส่งเสริมการขาย',
        value: 'promotion_name_th'
    }, {
        label: 'ประเภทบริการของรายการส่งเสริมการขาย',
        value: 'promotion_category'
    }, {
        label: 'ชนิดของรายการส่งเสริมการขาย',
        value: 'promotion_type'
    }, {
        label: 'จำนวนวันที่ให้บริการของรายการส่งเสริมการขายเสริม',
        value: 'number_of_service_days'
    }, {
        label: 'วันเริ่มต้นของการเสนอขาย',
        value: 'start_sale_date'
    }, {
        label: 'วันสิ้นสุดของการเสนอขาย',
        value: 'end_sale_date'
    }, {
        label: 'ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน',
        value: 'promotion_price'
    }, {
        label: 'ให้บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง ภาษาไทย)',
        value: 'privilege_content_th'
    }, {
        label: 'ให้บริการโซเชียลมีเดีย (ภาษาไทย)',
        value: 'privilege_social_th'
    }, {
        label: 'ให้บริการเกม (ภาษาไทย)',
        value: 'privilege_game_th'
    }, {
        label: 'พรีเมียม (ภาษาไทย)',
        value: 'privilege_premium_th'
    }, {
        label: 'อุปกรณ์อื่นๆ (ภาษาไทย)',
        value: 'privilege_device_th'
    }, {
        label: 'ให้บริการอื่นๆ (ภาษาไทย)',
        value: 'privilege_other_th'
    }, {
        label: 'รูปแบบการคิดค่าบริการประเภทเสียง',
        value: 'service_charge_type'
    }, {
        label: 'ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ',
        value: 'promotion_link_url'
    }, {
        label: 'หมายเลข USSD สำหรับเปลี่ยนรายการส่งเสริมการขาย',
        value: 'promotion_ussd'
    }]
}

const actions = {
    async setProvider({ commit }, data) {
        let result = await Promotion_service.setProvider();
        if (result.status === 200) {
            state.provider = [];
            state.provider = result.data;
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async searchPopularPromotion({commit}, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        state.loading = true
        commit('SET_FORM_DOWNLOAD', data)
        if(data.form.quarter != '' && data.form.year != ''){
            let start = moment(data.form.year).add((data.form.quarter-1)*3, 'M').format('YYYY-MM-DD');
            let end = moment(start).add(3, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            data.form.dateRange[0] = start;
            data.form.dateRange[1] = end;
        } else {
            let quarter = moment(data.form.dateRange[0]).quarter();
            let year = moment(data.form.dateRange[0]).year();
            let start = moment(year + '-01-01').add((quarter-1)*3, 'M').format('YYYY-MM-DD');
            let end = moment(start).add(3, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            data.form.dateRange[0] = start;
            data.form.dateRange[1] = end;
        }
        let result = await Promotion_service.searchPopularPromotion(data);
        if (result.status === 200) {
            if (result.data.length > 0) {
                state.total = result.data[0].total ? result.data[0].total : 0
            } else {
                state.total = 0;
            }
            commit('SET_TABLE', result.data)
            setTimeout(function(){ loadingInstance.close() }, 250);
        } else {
            if (result.status === 230 || result.status === 225) {
                setTimeout(function(){ loadingInstance.close() }, 250);
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                }).catch(() => {
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                });
            } else {
                setTimeout(function(){ loadingInstance.close() }, 250);
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {}).catch(() => {});
            }
        }
    },

    async downloadPopularPromotion({commit}, data) {
        if(data.form.quarter != '' && data.form.year != ''){
            let start = moment(data.form.year).add((data.form.quarter-1)*3, 'M').format('YYYY-MM-DD');
            let end = moment(start).add(3, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            data.form.dateRange[0] = start;
            data.form.dateRange[1] = end;
        } else {
            let quarter = moment(data.form.dateRange[0]).quarter();
            let year = moment(data.form.dateRange[0]).year();
            let start = moment(year + '-01-01').add((quarter-1)*3, 'M').format('YYYY-MM-DD');
            let end = moment(start).add(3, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            data.form.dateRange[0] = start;
            data.form.dateRange[1] = end;
        }
        data.form.download = true
        let result = await Promotion_service.searchPopularPromotion(data);
        if (result.status === 200) {
            if (result.data.length > 0) {
                state.total = result.data[0].total ? result.data[0].total : 0
            } else {
                state.total = 0;
            }
            commit('SET_DOWNLOAD_DATA', result.data)
        } else {
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                }).catch(() => {
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                });
            } else {
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {}).catch(() => {});
            }
        }
    }
}

const mutations = {
    SET_FORM_DOWNLOAD(state, data){
        state.download_form = JSON.parse(JSON.stringify(data))
    },
    SET_TABLE(state, data) {
        state.data_table = data
        state.loading = false
    },
    SET_DOWNLOAD_DATA(state, data){
        let promotion = data
        promotion.forEach(function(val){
            val.created_at = val.created_at != null ? moment(val.created_at).add(543, 'y').format('DD/MM/YYYY') : ''
            val.start_sale_date = val.start_sale_date != null ? moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.end_sale_date = val.end_sale_date != null ?  moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.start_service_date = val.start_service_date != null ? moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') : ''
            val.end_service_date = val.end_service_date != null ? moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') : ''
        })
        state.download_data = promotion
    },
    CUT_TABLE(state, data) {
        let index = state.data_table.findIndex(x => x.promotion_code === data);
        state.data_table.splice(index, 1)
    }
}

export const Report_popular_mobile = {
    namespaced: true,
    state,
    actions,
    mutations
}